import { api } from '../client';

export const blueprint = {
  list: api.listBlueprints,
  saveDraft: api.saveBlueprintDraft,
  publish: api.publishBlueprintAsConductor,
};
